import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { HealthComponent } from './health/health.component';
import { IsAnonymousGuard } from './guards/is-anonymous.guard';
import { IsAuthenticatedGuard } from './guards/is-authenticated.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { PasswordRequestComponent } from './password-request/password-request.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SignInComponent } from './sign-in/sign-in.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'patients',
    pathMatch: 'full',
  },
  {
    path: 'sign-in',
    component: SignInComponent,
    canActivate: [IsAnonymousGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'password-request',
    component: PasswordRequestComponent,
    canActivate: [IsAnonymousGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [IsAnonymousGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
    canActivate: [IsAnonymousGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'patients',
    loadChildren: () =>
      import('../patients/patients.module').then((m) => m.PatientsModule),
    canActivate: [IsAuthenticatedGuard],
    runGuardsAndResolvers: 'always',
    data: {
      hasHeader: true,
      layout: 'fullscreenLayout',
    },
  },
  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: 'health',
    component: HealthComponent,
    canActivate: [IsAnonymousGuard],
    runGuardsAndResolvers: 'always',
  },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
